import React from 'react'
import large2 from '../../assets/images/services/large/02.jpg'
import HeroSection4 from '../../Components/heroSection/HeroSection4'
import BlogSection2 from '../../Components/blogSection/BlogSection2'

const DigitalMarketing = () => {
  return (
    <>
      <HeroSection4 name={"UI/UX Experience"} name2={"Home"} />
      <BlogSection2 bgImage={large2} selected={2} />
    </>
  )
}

export default DigitalMarketing